import React, { useState } from 'react';
import { ReactCookieProps } from 'react-cookie';
import Input from '~components/Input';
import DateInputWithCalendarIcon from '~components/DateInputWithCalendarIcon';
import useContactForm, {
  ContactFormFieldNames,
} from '~utils/hooks/useContactForm';
import { BREAKPOINTS } from '~constants/media';
import {
  Form,
  InputWrapper,
  SubmitButton,
  SubmitSuccessMessage,
  WomanDiv,
} from './styledComponents';
import { useHistory } from 'react-router-dom';
import woman from './images/womanForm.png';

export type Props = ReactCookieProps & {
  postFn: (data: Record<ContactFormFieldNames, string>) => Promise<unknown>;
  fieldNames: ContactFormFieldNames[];
  formId?: string;
  columnBreakpoint?: string;
  submitButtonLabel?: string;
  totalArea?: { from: number; to: number } | undefined;
  sumbitSuccessComponent?: JSX.Element;
  heading?: JSX.Element;
  afterSubmit?: () => void;
};

const ContactForm = ({
  columnBreakpoint = `${BREAKPOINTS.lg}px`,
  submitButtonLabel = 'Отправить',
  sumbitSuccessComponent = (
    <SubmitSuccessMessage>
      <div>Ваше сообщение отправлено.</div>
    </SubmitSuccessMessage>
  ),
  fieldNames,
  heading,
  postFn,
  afterSubmit,
  /**for analytics */
  formId,
  totalArea,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
  const {
    form: { formData, isFormValid },
    inputProps,
  } = useContactForm({
    fieldNames,
  });

  const showSubmitSuccessComponent =
    isSubmitSuccessful && !!sumbitSuccessComponent;

  const history = useHistory();

  const sendContactForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setIsLoading(true);

    postFn(formData)
      .then(() => {
        setIsLoading(false);
        setIsSubmitSuccessful(true);

        if (afterSubmit) {
          afterSubmit();
        }
        history.push('/search', {
          areaFrom: totalArea && totalArea.from,
          areaTo: totalArea && totalArea.to,
          currencyId: 1,
          type: 'office',
          typeListing: 'rent',
        });
      })
      .catch(() => {
        setIsLoading(false);
        setIsSubmitSuccessful(false);
      });
  };
  return (
    <div>
      {showSubmitSuccessComponent ? (
        sumbitSuccessComponent
      ) : (
        <div style={{ display: 'flex', alignItems: 'flexStart' }}>
          <WomanDiv>
            <img
              style={{ width: '100%', height: '100%' }}
              src={woman}
              alt='woman'
            />
          </WomanDiv>
          <div>
            {heading}
            <Form
              id={formId}
              columnBreakpoint={columnBreakpoint}
              onSubmit={sendContactForm}
            >
              {inputProps.map((props) => {
                return (
                  <InputWrapper
                    key={props.name}
                    columnBreakpoint={columnBreakpoint}
                  >
                    {props.name === 'date' ? (
                      <DateInputWithCalendarIcon
                        name={props.name}
                        value={props.value}
                        placeholderText='Дата просмотра'
                        onBlur={() => props.onBlur(props.name, props.value)}
                        onChange={(val) => props.onChange(props.name, val)}
                        hasError={props.hasError}
                      />
                    ) : (
                      <Input {...props} />
                    )}
                  </InputWrapper>
                );
              })}
              {/* <div> */}
              <SubmitButton
                type='submit'
                borderRadius='rounded'
                /* oder classname is used for analytics */
                className='oder'
                disabled={!isFormValid() || isLoading}
                columnBreakpoint={columnBreakpoint}
              >
                {submitButtonLabel}
              </SubmitButton>
              {/* </div> */}
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
